import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { PostRegisterRequest, PostRegisterErrorResponse } from './types';
import { GetRegisterResponse } from '../get';

export const postRegister = async (data: PostRegisterRequest, lang = 'en', token: string | null | undefined): Promise<GetRegisterResponse> => {
	const headers = {
		'Content-Type': 'application/json',
		...(token && { "X-XSRF-TOKEN": token }),
	};
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/register?${queryParams.join('&')}`, {
		method: 'POST',
		credentials: 'include',
		headers: headers,
		body: JSON.stringify(data),
	})
		.then((res) => {
			if (res.ok) return res.json().then(response => response as GetRegisterResponse);
			return res.json().then(errorResponse => {
				throw errorResponse as PostRegisterErrorResponse
			});
		})
		.then((successResponse) => successResponse)
		.catch((error: PostRegisterErrorResponse) => {
			throw error;
		});
};